/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aitextuse2Inputs */

const en_aitextuse2 = /** @type {(inputs: Aitextuse2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use this text`)
};

const de_aitextuse2 = /** @type {(inputs: Aitextuse2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Text übernehmen`)
};

/**
* | output |
* | --- |
* | "Use this text" |
*
* @param {Aitextuse2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aitextuse2 = /** @type {((inputs?: Aitextuse2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aitextuse2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aitextuse2(inputs)
	return de_aitextuse2(inputs)
});
export { aitextuse2 as "aiTextUse" }